export enum LineOwnerType {
    /** Type 0 (Neuanschluss) */
    NEW_CONNECTION = 0,
    /** Type 1 (Anschlussinhaber) */
    SUBSCRIBER = 1,
    /** Type 2 (Vormieter) */
    PREVIOUS_TENANT = 2,
    /** Type 3 (3er Prozess) */
    THREE_WAY_PROCESS = 3,
}
